import { HttpErrorResponse } from '@angular/common/http';

export function isHttpError(error: unknown): error is HttpErrorResponse {
    return error instanceof HttpErrorResponse;
}

export function isHttpBadRequestError(error: unknown): error is HttpErrorResponse {
    return isHttpError(error) && error.status === 400;
}

export function isHttpForbiddenError(error: unknown): error is HttpErrorResponse {
    return isHttpError(error) && error.status === 403;
}

export function isHttpNotFoundError(error: unknown): error is HttpErrorResponse {
    return isHttpError(error) && error.status === 404;
}
